/**
 * IMPORTS
 */

import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@components/button/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@components/card/card";
import { SearchInput } from "@components/search/search";
import { SpinnerTable } from "@components/spinner-table/spinner-table";
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@components/table/table";

import { ManagerCreditsMainTable } from "@pages/admin/gerenciar-creditos/components/manager-credits-main-table/manager-credits-main-table";

export function ManagerCreditsTable({
  isLoadingPage,
  credits,
  offset,
  totalCredits,
}: {
  isLoadingPage: boolean;
  credits: any[];
  offset: number;
  totalCredits: number;
  nextPaginate(): void;
}) {
  const creditsPerPageDefault = 5;

  return (
    <Card>
      <CardHeader className="items-center justify-between">
        <div>
          <CardTitle>Histórico de movimentações </CardTitle>
        </div>
        <div>
          <SearchInput />
        </div>
      </CardHeader>

      {isLoadingPage ? (
        <SpinnerTable />
      ) : (
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Produto</TableHead>

                <TableHead className="hidden md:table-cell">Créditos</TableHead>

                <TableHead className="hidden md:table-cell">Responsável</TableHead>

                <TableHead className="hidden md:table-cell">Dataa</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {credits.map((credit) => (
                <ManagerCreditsMainTable key={credit.id} credits={credit} />
              ))}
            </TableBody>
          </Table>
        </CardContent>
      )}

      <CardFooter>
        <form className="flex w-full items-center justify-between">
          <div className="text-xs text-muted-foreground">
            Mostrando{" "}
            <strong>
              {Math.min(offset - creditsPerPageDefault, totalCredits) + 1}-{offset}
            </strong>{" "}
            de <strong>{totalCredits}</strong> expedições
          </div>
          <div className="flex">
            <Button
              // formAction={prevPage}
              variant="ghost"
              size="sm"
              type="submit"
              disabled={offset === creditsPerPageDefault}
            >
              <ChevronLeft className="mr-2 h-4 w-4" />
              Voltar
            </Button>
            <Button
              // formAction={nextPage}
              variant="ghost"
              size="sm"
              type="submit"
              disabled={offset + creditsPerPageDefault > totalCredits}
            >
              Proxímo
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </form>
      </CardFooter>
    </Card>
  );
}
